import axiosInstance from './Api';

export default {

  async getCountriesAndCities() {

    let response = await axiosInstance().get(`/home/countries-and-cities`);

    return response;
  },

  async getCourseLevels() {

    let response = await axiosInstance().get(`/home/course-levels`);

    return response;
  },

  async getCourseCategories() {

    let response = await axiosInstance().get(`/home/course-categories`);

    return response;
  },

  async getTuitionFeesFilterValues() {

    let response = await axiosInstance().get(`/home/tution-fees-filter-values`);

    return response;
  },

  async getTuitionUSDFeesFilterValues() {

    let response = await axiosInstance().get(`/home/tution-fees-filter-values-usd`);

    return response;
  },

}



// WEBPACK FOOTER //
// ./src/apiServices/masterServices.js